<div class="page-header-container">
    <div class="page-title">
        {{'requests.clientData.newRequest.Title' | translate}}
    </div>
</div>

<div class="wizard-container" *ngIf="isDataLoaded">
    <button class="btn link-btn btn-back-txt" (click)="redirectFieldSelectionHandler()">
        <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
        <span>{{'requests.clientData.newRequest.Back' | translate}}</span>
    </button>

    <div class="row">
        <span class="col-12 d-flex justify-content-center title">{{'requests.clientData.newRequest.contactInformation.Title' | translate}}</span>
    </div>

    <form #form="ngForm">
        <div class="row justify-content-between justify-content-around">
            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-4">
                <label class="text-field-label">{{'requests.clientData.newRequest.contactInformation.Email' | translate}} 
                    <span class="text-primary fw-bold">*</span>
                </label>
        
                <input kendoTextBox 
                    class="text-input"  
                    [(ngModel)]="clientDataRequestSaveModel.contactInformation.email" 
                    required 
                    name="email"
                    #email="ngModel"/>
                <div class="error-info" *ngIf="email.invalid  && (email.dirty || form.submitted)">
                    <div  *ngIf="email.errors?.['required']">
                        {{'common.validation.required' | translate}}
                    </div>
                </div>  
            </div>

            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-4">
                <label class="text-field-label">{{'requests.clientData.newRequest.contactInformation.Phone' | translate}} 
                    <span class="text-primary fw-bold">*</span>
                </label>
                <input kendoTextBox 
                    class="text-input" 
                    [(ngModel)]="clientDataRequestSaveModel.contactInformation.phone" 
                    type="text" 
                    required 
                    name="phone"
                    #phone="ngModel"/>
                <div class="error-info" *ngIf="phone.invalid  && (phone.dirty || form.submitted)">
                    <div  *ngIf="phone.errors?.['required']">
                        {{'common.validation.required' | translate}}
                    </div>
                </div>  
            </div>
        </div>

        <div class="row justify-content-between justify-content-around"*ngIf="isPJ">
            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-4">
                <span class="text-field-label">{{'requests.clientData.newRequest.contactInformation.Fax' | translate}}</span>
                    <input kendoTextBox 
                        class="text-input"  
                        [(ngModel)]="clientDataRequestSaveModel.contactInformation.fax" 
                        type="number" 
                        name="fax"/>
            </div>
            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-4">   </div>
        </div>

        <div class="d-flex justify-content-center mt-4">
            <button class="btn primary-btn px-5" 
                (click)="sendRequestCofirmationHandler()" 
                [disabled]="isSendButtonDisabled">
                <span>
                    {{ 'requests.clientData.newRequest.Next' | translate}}
                </span>
            </button>
        </div>
    </form>
</div>